import getConfig from 'next/config';
import useCopy from '../../../../partner-pages/utils/hooks/use-copy';
import { handleTrack } from '../../../../../utils/tracker';
import { If } from '../../../../Atoms/Conditionals';
import { CompactCardProps } from '../compact-cards.types';

const { publicRuntimeConfig } = getConfig();

export const LuxuryTaxSupportCompact = (dataObj: CompactCardProps) => {
  const { copied, handleCopyCoupon } = useCopy(dataObj.coupon_code || '', 1000);
  const baseUrl = publicRuntimeConfig.CLEARTAX_DOMAIN;
  const checkoutUrl = dataObj.coupon_code
    ? `${baseUrl}/checkout/${dataObj.listingId}?coupon=${dataObj.coupon_code}&utm_ref=${dataObj.utm_ref}`
    : `${baseUrl}/checkout/${dataObj.listingId}?utm_ref=${dataObj.utm_ref}`;
  const servicesUrl = `${baseUrl}/services/${dataObj.planId}/p?utm_ref=${dataObj.utm_ref}`;

  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.preventDefault();
    handleTrack({
      label: 'showcase-fold_',
      obj: e.target,
      value: checkoutUrl,
    });
    window.location.href = checkoutUrl;
  };

  const handleCouponClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    e.stopPropagation();
    handleCopyCoupon();
    handleTrack({
      label: 'plan-card_copy',
      obj: e.target,
      value: dataObj.coupon_code,
    });
  };

  const handleLinkClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    url: string
  ) => {
    e.stopPropagation();
    handleTrack({
      label: 'showcase-fold_',
      obj: e.target,
      value: url,
    });
  };

  return (
    <div
      className="border-sm border-yellow-500 rounded-3xl my-16 text-black hover:cursor-pointer w-1/2 sm:w-full flex"
      onClick={handleClick}
    >
      <div className="pl-10 pr-0 py-8 bg-[url('https://assets.clear.in/cleartax/images/1746007827_bgluxuryfiling.svg')] rounded-3xl sm:pl-4 sm:pr-0 flex flex-col w-full">
        <div className="md:min-h-[100px] lg:min-h-[120px] pr-14 sm:pr-6">
          <div className="text-s-32 font-bold leading-8 tracking-normal sm:pt-6">
            {dataObj.heading_1}
          </div>
        </div>

        <div className="flex-1 pr-14 sm:pr-6">
          <ul className="pt-8 space-y-3 pb-8 sm:pb-8">
            {dataObj.description?.map((item, index) => (
              <li key={index} className="flex items-start gap-2">
                <img src="https://assets.clear.in/cleartax/images/1746011699_checkcircle.svg" />
                <span className="text-base font-normal leading-6">{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-auto flex flex-col gap-8 sm:gap-6">
          <div className="flex flex-wrap-reverse justify-end items-center gap-4">
            <div id="luxury-support-compact-price" className="flex-1 pr-4">
              <div className="flex items-center gap-2">
                <span
                  id="luxury-support-compact-offer-price"
                  className="text-s-32 sm:text-2xl font-bold"
                >
                  {dataObj.price}
                </span>
                {dataObj.original_price && (
                  <span
                    id="luxury-support-compact-original-price"
                    className="text-lg sm:text-base text-gray-400 line-through"
                  >
                    {dataObj.original_price}
                  </span>
                )}
                {dataObj.discount && (
                  <span
                    id="luxury-support-compact-discount"
                    className="text-lg sm:text-base text-gray-400"
                  >
                    ({dataObj.discount})
                  </span>
                )}
              </div>
              <div className="text-base sm:text-sm font-medium text-gray-400 pt-1">
                Offer Price (inclusive of taxes)
              </div>
            </div>

            <If condition={Boolean(dataObj.coupon_code)}>
              <div
                className="bg-[#FEF6DC] px-5 py-3 rounded-l-2xl rounded-r-none flex flex-col items-center cursor-pointer shrink-0"
                onClick={handleCouponClick}
              >
                <div className="text-s-20 font-bold text-[#303B4D] whitespace-nowrap">
                  Extra{' '}
                  <span id="luxury-support-compact-coupon-discount">
                    {dataObj.coupon_discount}
                  </span>{' '}
                  OFF
                </div>
                <div className="flex items-center gap-1 pt-1">
                  <span className="text-s-14 text-gray-500">Code: </span>
                  <span
                    id="luxury-support-compact-coupon-code"
                    className="text-s-14 text-[#1678FB] font-bold uppercase"
                  >
                    {dataObj.coupon_code}
                  </span>
                  <img
                    className="w-5 h-5 ml-1"
                    src={
                      copied
                        ? 'https://assets.clear.in/cleartax/images/1712001391_checkcircle1.svg'
                        : 'https://assets.clear.in/cleartax/images/1714203952_copy.svg'
                    }
                    alt="copy coupon"
                  />
                </div>
              </div>
            </If>
          </div>

          <div className="flex sm:flex-col sm:gap-6 items-center pr-14 sm:pr-6">
            <a
              id="luxury-support-compact-buy-now"
              className="bg-gray-800 font-bold text-base py-3 px-16 text-white rounded-md text-center sm:w-full"
              href={checkoutUrl}
              onClick={(e) => handleLinkClick(e, checkoutUrl)}
            >
              Buy Now
            </a>
            <a
              id="luxury-support-compact-know-more"
              className="text-base font-bold px-6 text-center flex gap-2 text-black"
              href={servicesUrl}
              target="_blank"
              onClick={(e) => handleLinkClick(e, servicesUrl)}
              rel="noreferrer"
            >
              Know More
              <img
                className="pt-0.25"
                src="https://assets.clear.in/cleartax/images/1746015148_vector.svg"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
